export const getVisibilityLabels = (isChecked: boolean) => ({
	button: isChecked ? "Visible" : "Hidden",
	tooltip: isChecked ? "Visible on portal" : "Hidden from portal",
})

export interface VisibilityOption {
	value: boolean
	label: string
	description: string
}

export const getVisibilityOptions = (
	allPortals: boolean,
): VisibilityOption[] => [
	{
		value: true,
		label: "Visible",
		description: allPortals
			? "Listed on every portal for customers to find and upvote."
			: "Listed on your public portal for customers to find and upvote.",
	},
	{
		value: false,
		label: "Hidden",
		description: "Kept inside your workspace, where only your team sees it.",
	},
]

// With feature requests off, no customer can see an issue or project, so a visibility control has nothing to change.
export function showsPortalVisibility(
	workspace: { domainPublic?: boolean | null } | null | undefined,
) {
	return workspace?.domainPublic === true
}
